import * as React from "react";
import { SVGProps } from "react";
const SvgCheckbox = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 32 32" {...props}>
    <g clipPath="url(#checkbox_svg__a)">
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M16 0c3.589 0 7.277.3 10.766.998 2.094.4 3.789 2.097 4.187 4.194a56.066 56.066 0 0 1 0 21.566c-.398 2.097-2.093 3.794-4.187 4.194a55.809 55.809 0 0 1-21.532 0c-2.094-.4-3.789-2.097-4.187-4.194a56.066 56.066 0 0 1 0-21.566C1.445 3.095 3.14 1.398 5.234.998 8.723.3 12.41 0 16 0Zm0 1.997c-3.49 0-6.978.3-10.467.998-1.137.285-2.183 1.2-2.456 2.404l-.037.192-.138.767a56.49 56.49 0 0 0 .138 20.1c.285 1.139 1.199 2.187 2.4 2.46l.957.176a56.23 56.23 0 0 0 20.07-.14c1.197-.299 2.293-1.297 2.493-2.595a56.488 56.488 0 0 0 0-20.868c-.19-1.14-1.104-2.191-2.31-2.461l-1.055-.201c-3.198-.58-6.397-.832-9.595-.832Z"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="checkbox_svg__a">
        <path fill="#fff" d="M0 0h32v32H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgCheckbox;
